<template>
  <div>
    <videos @onSelect="onSelect"></videos>
  </div>
</template>

<script>
import api from '@/api'
import Videos from './Videos'
export default {
  data: function() {
    return {
      videolist: []
    }
  },
  components: { Videos },
  mounted() {},
  methods: {
    onSelect(payload) {
      this.$emit('onSelect', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/intent/VideoList.vue